import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const ProtectedLayout = ({ allowedRoles }: { allowedRoles: string[] }) => {
  const { userContext } = useAuth();

  if (!userContext) {
    return <Navigate to="/connexion" replace />;
  } else if (!allowedRoles.includes(userContext.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ProtectedLayout;
